var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:("tutorial-block variant-" + _vm.variant),style:({ backgroundImage: _vm.backgroundImage }),attrs:{"to":_vm.to}},[_c('h2',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }